import { Column } from 'react-table';
import { TextColumn } from 'shared/tables/columns';
import { QuoteDownloadFileColumn } from 'shared/tables/columns/quote-file-download-column';
import { AdditionalQuoteDocumentationItem } from 'shared/types/quoteReview';
import { QuoteFileDeleteColumn } from './quote-file-delete-column';

export const additionalQuoteDocumentationTableColumns: Column<AdditionalQuoteDocumentationItem>[] = [
  {
    Header: 'Document Name',
    accessor: 'documentName',
    Cell: QuoteDownloadFileColumn,
    align: 'left',
  },
  {
    Header: 'Document Type',
    accessor: 'documentType',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'User',
    accessor: 'user',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Upload Date',
    accessor: 'uploadDate',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: ' ',
    accessor: 'id',
    Cell: QuoteFileDeleteColumn,
    align: 'center',
  },
];
